module.exports = __webpack_public_path__ + "static/media/Logo_logo.d2d32c76.png";